import { DigitaiFleetAircraft } from '@apps/digitai';

export const fleetAircraftCountMotors = (fleetAircraft: DigitaiFleetAircraft): number =>
{
    let nMotors = 0;
    if (fleetAircraft.engine1Id) nMotors++;
    if (fleetAircraft.engine2Id) nMotors++;
    if (fleetAircraft.engine3Id) nMotors++;
    if (fleetAircraft.engine4Id) nMotors++;

    return nMotors;
};

export const fleetAircraftGetEnginePositionsInstalled = (fleetAircraft: DigitaiFleetAircraft): number[] =>
{
    const positions = [];
    if (fleetAircraft.engine1Id) positions.push(1);
    if (fleetAircraft.engine2Id) positions.push(2);
    if (fleetAircraft.engine3Id) positions.push(3);
    if (fleetAircraft.engine4Id) positions.push(4);

    return positions;
};